import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import { BRAND } from '../../../config/configs';
import ROUTES from '../../../config/routes';
import Button from '../../ui/buttons/Button';

const NAV_LINKS = [
  { label: 'Services', path: ROUTES.SERVICES },
  { label: 'Our Work', path: ROUTES.WORK },
  { label: 'Robotics', path: ROUTES.ROBOTICS },
//   { label: ADOPTAFRICA, path: ROUTES.ADOPT },
  { label: 'About', path: ROUTES.ABOUT },
];

// Pages where navbar starts transparent
const TRANSPARENT_ROUTES = [ROUTES.ROBOTICS];

export default function Navbar() {
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    // mobile state
    const [isMobile, setIsMobile] = useState(false)

    const isTransparentPage = TRANSPARENT_ROUTES.includes(location.pathname);
    const isTransparent = isTransparentPage && !scrolled;

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 80);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => { setMenuOpen(false); }, [location]);

    useEffect(() => {
        document.body.style.overflow = menuOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [menuOpen]);

    const isActive = (path) => location.pathname === path;

    const checkScreenSize = () => {
        setIsMobile(window.innerWidth <= 768)
    }

    useEffect(() => {
        checkScreenSize()
    }, [])

    return (
        <header className={[
            'navbar',
            scrolled ? 'navbar--scrolled' : '',
            isTransparent ? 'navbar--transparent' : '',
        ].join(' ')}>
            <div className="container navbar__inner">

                <Link to={ROUTES.HOME} className="navbar__logo">
                    {BRAND.shortName}
                    <span className="navbar__logo-sub">Innovations</span>
                </Link>

                <nav className="navbar__links" aria-label="Main navigation">
                    {NAV_LINKS.map((link) => (
                        <Link
                        key={link.path}
                        to={link.path}
                        className={`navbar__link ${isActive(link.path) ? 'navbar__link--active' : ''}`}
                        >
                        {link.label}
                        </Link>
                    ))}
                </nav>

                <div className="navbar__actions">
                    <Link to={ROUTES.CONTACT} className="navbar__link hide-mobile">
                        Contact
                    </Link>
                    {!isMobile && (
                        <Button
                            to={ROUTES.CONTACT}
                            variant={isTransparent ? 'outline-white' : 'primary'}
                            size='md'
                        >
                            Book Strategy Session
                        </Button>
                    )}
                </div>

                <button
                    className={`navbar__hamburger ${menuOpen ? 'navbar__hamburger--open' : ''}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label={menuOpen ? 'Close menu' : 'Open menu'}
                    aria-expanded={menuOpen}
                >
                    <span /><span /><span />
                </button>
            </div>

            {menuOpen && (
                <div className="navbar__mobile" aria-label="Mobile navigation">
                    <nav className="navbar__mobile-links">
                        {NAV_LINKS.map((link) => (
                            <Link
                                key={link.path}
                                to={link.path}
                                className={`navbar__mobile-link ${isActive(link.path) ? 'navbar__mobile-link--active' : ''}`}
                            >
                                {link.label}
                            </Link>
                        ))}
                        <Link to={ROUTES.CONTACT} className="navbar__mobile-link">
                            Contact
                        </Link>
                    </nav>
                    <div className="navbar__mobile-cta">
                        <Button to={ROUTES.CONTACT} variant='primary' size='md' fullWidth>
                            Book Strategy Session
                        </Button>
                    </div>
                </div>
            )}
        </header>
    );
}